export default {"src":"/_next/static/media/menu.2d240737.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};